var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15.9,
    r: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,15.5v1.6H6.5H4.6H2v-1.6h2.6V9.3H4.5L2,11V9.2l2.6-1.7h1.8v8H9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,12.3c0,3.1-1.3,4.8-3.5,4.8c-2.2,0-3.5-1.7-3.5-4.8s1.3-4.8,3.5-4.8C20.7,7.5,22,9.2,22,12.3z M20,10.5   C19.7,9.5,19.2,9,18.5,9c-1.1,0-1.7,1.2-1.7,3.3c0,0.1,0,0.2,0,0.2L20,10.5z M17,14.2c0.3,0.9,0.8,1.4,1.5,1.4   c1.1,0,1.7-1.2,1.7-3.3c0-0.1,0-0.1,0-0.2L17,14.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloat);
export default __webpack_public_path__ + "static/media/float.92083e9d4c18428e9a1035212498471c.svg";
export { ForwardRef as ReactComponent };